export default "__VITE_ASSET__DP3F0w4V__"